import * as actions_admin from 'actions/admin-actions';
import * as actions_profiles from 'actions/profiles-actions';
import * as actions_schedule from 'actions/schedule-actions';
import * as actions_service_requests from 'actions/service-requests-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import moment from 'moment';
import { Avatar, FormBuilder, ValidateForm, ModalForm } from 'enspire-manager-framework';
import { APPS, ACTION, LOG, PERMISSIONS, ROLES, SERVICE_REQUEST_TERMS } from 'components/constants';
import { confirmAdd, confirmArchive, getProfileName } from 'components/common/toolbox';
import { imageSize } from 'components/common/toolbox';
import { service_request_fields, service_request_form_layout } from 'components/service-requests/asset-request/asset-request-form-layout';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';

const _ = require('lodash');

export default function ServiceRequestForm(props) {
	
	/* Hooks ------------------------------------------------------------------------------------------------------------------------------------*/
	
	const seg = 5;
	const history = useHistory();
	const params = useParams();
	const dispatch = useDispatch();
	const routeLocation = useLocation();

	const admin = useSelector((store) => store.admin);
	const assets = useSelector((store) => store.assets.assets);
	const employees = useSelector((store) => store.employees.employees);
	const features = useSelector((store) => store.settings?.settings?.features)?.[(params.appId == APPS.DISPATCH.id) ? 'dispatch' : 'assets'];
	const selectedAssetTypeId = useSelector((store) => store.assets.selected_asset_type_id);
	const selectedCustomerId = useSelector((store) => store.assets.selected_customer_id);
	const serviceRequest = useSelector((store) => store.serviceRequests.service_request);
	const serviceRequests = useSelector((store) => store.serviceRequests);
	const settings = useSelector((store) => store.settings);
	const user = useSelector((store) => store.users.user);
	const workOrders = useSelector((store) => store.workOrders);
    const user_permissions = useSelector(store => store.users?.user_permissions);

	const [focusedInput, setFocused] = useState(null);
	const [formError, setFormError] = useState(null);
	const [original, setOriginal] = useState({});
	const [request, setRequest] = useState(service_request_fields(props.type,
		(settings.settings?.work_orders?.default_technician_id) ? settings.settings.work_orders.default_technician_id : ''
	));
	
	const asset = _.find(assets, { id: params.asset_id });
	// const serviceRequest = serviceRequests.find((request) => request.id == params.request_id);
	const fromSchedule = props?.fromSchedule;
    const segments = props.location.pathname.split('/').length;

	/* Effects ------------------------------------------------------------------------------------------------------------------------------------*/

	useEffect(() => {
		if (parseInt(params.request_id)) {
			populateForm();
		} else {
			setRequest(prev => ({ ...prev, customerId: selectedCustomerId, assetTypeId: selectedAssetTypeId, assetId: params.asset_id }));
			handleDate('requestDate', request.requestDate);
		}
	}, [serviceRequest, selectedCustomerId, selectedAssetTypeId]);

	// If from schedule, set the start and end date to the dragged event
	useEffect(() => {
		if (fromSchedule) {
			setRequest(prev => ({ ...prev, requesttDate: workOrders.new_service_dragging.humanStartDate.toDate() }));
		}
	}, [serviceRequest]);

	/* Handlers ------------------------------------------------------------------------------------------------------------------------------------*/

	const handleChange = (e, value) => {
		let newValue = (value) ? value : e.target.value;
		let form_error = _.filter(formError, (o) => { return o.field !== e.target.name; });
		setFormError(form_error);
		setRequest(prev => ({ ...prev, [e.target.name]: newValue }));
	};
	const handleCheckbox = (field) => {
		setRequest(prev => ({ ...prev, [field]: !request[field] }));
	};
	const handleDate = (field, date) => {
		var form_error = _.filter(formError, (o) => { return o.field !== field; });
		setFormError(form_error);
		setRequest(prev => ({ ...prev, requestDate: date, endDate: moment(date).add(settings.settings?.work_orders?.default_duration ?? 2, 'hours').toDate() }));
	};
	const handleUpload = (field, imageUrl) => {
		setRequest({ ...request, imageUrl });
	};

	/* Typeahead Handlers --------------------------*/

	const handleTypeahead = (field, result) => {
		var form_error = _.filter(formError, (o) => { return o.field !== field; });
		setFormError(form_error);
		if (result?.[0]?.customOption) {
			confirmAdd("Vendor", () => {
				dispatch(actions_profiles.saveProfile({
					handle: params.handle, 
					profileId: '0', 
					profileForm: { displayName: result?.[0]?.target }, 
					profileType: 'VENDOR',
					callback: (profileId) => {
						setRequest(prev => ({ ...prev, [field]: [{ target: result?.[0]?.target, id: profileId }] }));
						dispatch(actions_admin.saveActivity(params.handle, LOG.VENDOR.key, ACTION.CREATED.key, profileId, result?.[0]?.target ));
					}
				}));	
			});
		} else if (result?.[0]?.id) {
			setRequest(prev => ({ ...prev, [field]: [{ target: result?.[0]?.target, id: result?.[0]?.id }] }));
		} else {
			setRequest(prev => ({ ...prev, [field]: [] }));
		}
	};
	
	/* Actions ------------------------------------------------------------------------------------------------------------------------------------*/

	const populateForm = async () => {
		if (serviceRequest) {
			let vendorName = await getProfileName(params.handle, serviceRequest.vendorId);
			let myServiceRequest = { 
				...serviceRequest, 
				requestDate: serviceRequest.requestDate.toDate(),
				vendorId: (serviceRequest.vendorId) ? [{ target: vendorName, id: serviceRequest.vendorId }] : [],
			}
			setRequest(myServiceRequest);
			setOriginal(myServiceRequest);
		};
	};
	const toggleLightbox = () => {
		let imagesAlt = asset.imagesAlt?.map((imageUrl) => {
			return ({ src: imageSize(imageUrl, 'lg') });
		});
		if (!admin.lightbox_show) dispatch(actions_admin.lightboxSources([
			{ src: imageSize(asset.imageUrl, 'lg') },
			...(asset.imagesAlt) ? imagesAlt : []
		]));
		dispatch(actions_admin.lightboxShow(!admin.lightbox_show));
	}
	const archiveRequest = () => {
		dispatch(actions_service_requests.archiveServiceRequest(params.handle, request, (serviceRequestId) => { 
			dispatch(actions_admin.saveActivity(params.handle, LOG.SERVICE_REQUEST.key, ACTION.ARCHIVED.key, params.request_id, request.description ));
			history.go((segments > seg+5) ? (-3) : (-2)); // extra back if Work Order column showing
		}));
	};
	const submitForm = () => {
		var form_error = ValidateForm(request, form_layout);
		setFormError(form_error);

		let newServiceRequest = { ...request,
			vendorId: (request.vendorId?.[0]?.id) ? request.vendorId[0].id : null,
			...(request.type == 'asset_record') ? { serviceRequestTermsId: SERVICE_REQUEST_TERMS.SERVICE_RECORD.id } : {},
		};
		
		if (fromSchedule) newServiceRequest.technicianId = workOrders.new_service_dragging.technicianId;

		if (!form_error?.length) {
			dispatch(actions_service_requests.saveServiceRequest(params.handle, newServiceRequest, user, (serviceRequestId, workOrderId) => {

				if (fromSchedule) dispatch(actions_schedule.cancelNewEvent());
				let action = (parseInt(params.request_id)) ? ACTION.MODIFIED.key : ACTION.CREATED.key;
				dispatch(actions_admin.saveActivity(params.handle, LOG.SERVICE_REQUEST.key, action, serviceRequestId, request.description, request, original ));

				if (!parseInt(params.request_id)) {
					history.goBack();
					// If not from schedule, navigate to the Work Order Items page
					if (!fromSchedule) {
						setTimeout(() => {
							let location = toolbox.modifyPath( routeLocation?.pathname, 4, `${params.asset_id}/form/0/service_requests/${serviceRequestId}/work_orders/${workOrderId}/items`, 11);
							history.push({ pathname: location });
						}, 250);
					}
				} else {
					history.goBack();
				}
			}));
		}
	};

	/* Constants ------------------------------------------------------------------------------------------------------------------------------------*/

	const technicians = _.filter(employees, (o) => { return o.roles?.includes(ROLES.TECHNICIAN.id) || o.roles?.includes(ROLES.LEAD.id) });
	const classification = _.find(settings.settings_asset_classifications, { id: asset?.classificationId });
	const existing = (params.request_id > 0);
	const serviceType = (props.type == 'asset_record') 
		? 'Asset Completed Service Record' 
		: (props.type == 'asset_request')
			? 'Asset Service Request'
			: 'Asset Recurring Maintenance';

	const assetAvatar = (asset) ? 
		<div className="col-12">
			<div className="profile-image" onClick={ (asset.imageUrl) ? toggleLightbox : null }>
				<Avatar className="mx-auto"
					color="white"
					bgColor="saddleBrown"
					size={90}
					name={asset.name}
					image={imageSize(asset.imageUrl, 'sm')}
					border="4px solid white"
					role={ (asset.imageUrl) ? "button" : null }
				/>
			</div>
			<div className="profile-info pt-1">
				<h1>{asset.name}</h1>
				<h4>
					<span className="mr-3">{`#${asset.unitNumber}`}</span>
					<span className={ 'mb-3 badge badge-secondary' }>{classification?.name}</span>
				</h4>
			</div>
		</div> : null;

	const form_layout = service_request_form_layout({
		assetAvatar,
		features,
		firebase, 
		handle: params.handle, 
		serviceRequest: request,
		technicians,
		user_permissions,
	});

	/* Render ------------------------------------------------------------------------------------------------------------------------------------*/

	return (

		<ModalForm {...props}
			history={history}
			style={1}
			size={'xl'}
			modal_header={serviceType}
			cancel_button_title="Cancel"
			save_button_title={`Save ${serviceType}`}
			submitFormHandler={submitForm}
			delete_button_title={'Archive'}
			delete_button_callback={(!existing) ? null : () => confirmArchive('Service Request', archiveRequest)}
			delete_button_disabled={ !user_permissions[PERMISSIONS.SERVICE_REQUESTS_DELETE.key] }
			show_spinner={serviceRequests?.service_request_save_pending}
			focusedInput={(window.flutter) ? focusedInput : null}
			platform={admin.flutter_platform}
			keyboardPadding={admin.flutter_keyboard}
		>
			{request &&
				<FormBuilder
					callbacks={{
						focus: (event) => setFocused(event.target),
						text: handleChange,
						select: handleChange,
						typeahead: handleTypeahead,
						date: handleDate,
						checkbox: handleCheckbox,
						dropzone: handleUpload,
					}}
					form_error={formError}
					form={form_layout}
					record={request}
				/>
			}
		</ModalForm>
	);
}